<div class="empty-content flex flex-row justify-center items-center full-grow-no-shrink-no-basis" *ngIf="isEmpty">
  <div class="text-container">
    <img
      src="https://s3-us-west-2.amazonaws.com/orbitaxservices.com/orbitax-assets/images/orbitax-images/reports-empty.png"
      alt="Empty images">
    <h1>Attachment cannot be opened</h1>
    <div class="text">Please open the <a (click)='navigateToTaskManager()'>Task Manager</a> and find the task to open
      the attachment
    </div>
  </div>
</div>
<div class="page-layout carded left-sidenav toolbar-fixed-layout" *ngIf="!isEmpty">
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container w-p-100 flex flex-col justify-center items-start">
      <particle-breadcrumbs [breadcrumbs]="breadcrumbs"></particle-breadcrumbs>
    </div>
    <div class="flex flex-row justify-start items-center">
      <div class="avatar-container flex flex-row justify-end items-center" *ngIf="item">
        <particle-user-activity [endpoint]="endpointName" [sourceId]="item.id"></particle-user-activity>
      </div>
    </div>
  </div>
  <div class="toolbar second-level-toolbar flex flex-row justify-between items-center">
    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <label class="component-label"> Actions</label>
      <div class="grid-toolbar-buttons-group flex flex-row justify-start items-center">
        <div class="button-container flex flex-row justify-start items-center" *ngIf="showLanguageOption">
          <mat-slide-toggle [(ngModel)]="showOriginal" (change)="showOriginalChanged()">Original Language
          </mat-slide-toggle>
          <div class="toolbar-separator m-lr-10"></div>
        </div>
        <!--        <div *ngIf="!isReview" class="button-container" fxLayout="row" fxLayoutAlign="start center">-->
        <!--          <mat-slide-toggle [(ngModel)]="autoSave" (change)="autoSaveChanged()">Auto Save</mat-slide-toggle>-->
        <!--          <div class="toolbar-separator"></div>-->
        <!--        </div>-->
      </div>
    </div>

    <div class="grid-toolbar-buttons-group-container flex flex-col justify-center items-start">
      <div class="grid-toolbar-buttons-group-without-label flex flex-row justify-start items-center">
        <div *ngIf="isReview" class="m-r-10 flex flex-row justify-start items-center">
          <button mat-button class="reject-changes m-r-10" (click)="rejectResponse()"><i class="fas fa-times"></i>
            Reject Changes
          </button>
          <button mat-button class="submit-changes" (click)="acceptResponse()"><i class="fas fa-check"></i> Approve
            Changes
          </button>
        </div>
        <div *ngIf="!isReview" class="flex flex-row justify-start items-center">
          <button mat-button class="save-changes m-r-10" (click)="save()"
                  particleAnalytics
                  analyticsCategory="Save"
                  analyticsAction="Save"
                  [disabled]="this.editedFields.length==0">
            <i class="fas fa-check"></i> Save Changes ({{this.editedFields?.length}})
          </button>
          <button mat-button class="start-data-survey" (click)="submitResponse()"><i class="fal fa-play"></i> Submit
            Response
          </button>
        </div>
      </div>
    </div>

  </div>

  <mat-sidenav-container>

    <!-- CENTER -->
    <div class="center">

      <!-- CONTENT CARD -->
      <div class="content-card mat-white-bg">
        <!-- CONTENT TOOLBAR -->
        <div [ngClass]="containerClass" class="flex flex-col full-grow-no-shrink-no-basis">
          <particle-dynamic-form-container class="particle-dynamic-form-container"
                                           *ngIf="formField && item && fieldConfig"
                                           [formField]="formField"
                                           [fieldConfig]="fieldConfig"
                                           [sourceType]="sourceType"
                                           [endpointName]="endpointName"
                                           [item]="item"
                                           [showDelete]="showDelete"
                                           [invalidateSubject]="invalidateSubject"
                                           [showLanguageOption]="showLanguageOption"
                                           [editedFields]="editedFields"
                                           (valueChanged)="onValueChanged($event)"
          >

          </particle-dynamic-form-container>

        </div>
      </div>
      <!-- / CONTENT CARD -->

    </div>
    <!-- / CENTER -->

  </mat-sidenav-container>

</div>
